
    import './styles.scoped.css';
    export default {
  "css-grid": "awsui_css-grid_zqq3x_pc1h3_177",
  "grid-no-gutters": "awsui_grid-no-gutters_zqq3x_pc1h3_188",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_zqq3x_pc1h3_191",
  "item": "awsui_item_zqq3x_pc1h3_191",
  "first-column": "awsui_first-column_zqq3x_pc1h3_210"
};
  